import {
  tolgee,
  availableLanguages,
  availableLocales,
  language,
  locale,
  LangToLocaleMap,
  AvailableLanguage,
  getLocale,
} from '../../integrations/tolgee/instance.js'
import {TolgeeProvider} from '../../integrations/tolgee/provider.js'
import {persistLanguage} from './persistence.js'

export const Tolgee = {
  Provider: TolgeeProvider,
  instance: tolgee,
  availableLanguages,
  availableLocales,
  /**
   * The currently selected language.
   * @example 'en'
   */
  language,
  /**
   * The currently selected locale.
   * @example 'en-GB'
   */
  locale,
  persistLanguage(value: string) {
    const [lang] = value.split('-')
    if (!lang || !Object.keys(LangToLocaleMap).includes(lang)) return 'en'

    this.language = lang as AvailableLanguage
    this.locale = getLocale(value)

    persistLanguage(value)
  },
}
